<div class="reviews-outer" [formGroup]="amenitiesForm">
  <h2 class="trinidad-bold">What type of amenities is at this location?</h2>
  <p class="wizard-paragraph _12px">
    Let us know of any amenities that are available at this location. Please be as accurate as possible.
  </p>
  <div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="electricity"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Electricity</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="electricity"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="water"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Potable Water</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="potableWater"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="dump"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Dump Station</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="dumpStation"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="sewage"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Sewage</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="sewage"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="cell"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Cell Phone Coverage</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="cellPhoneCoverage"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="wifi"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">WiFi</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="wifi"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="firesAllowed"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Campfires Allowed</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="firesAllowed"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="petsAllowed"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Pets Allowed</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="petsAllowed"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="trash"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Trash Provided</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="trashProvided"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="recycling"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Recycle Provided</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="recycleProvided"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="table"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Picnic Table</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="picnicTable"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="restroom"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Toilet Available</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="toiletAvailable"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="shower"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Shower</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="shower"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="laundry"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Laundry</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="laundry"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="tents"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Tents allowed</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="tentsAllowed"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="vehicles"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Vehicles Allowed</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="vehiclesAllowed"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="pool"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Hot Tub / Pool</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="pool"></curbnturf-rating-availability-toggle>
    </div>
  </div>
  <div class="button-wrapper">
    <a role="button" class="button trinidad center w-button" (click)="onContinue()">Continue</a>
  </div>
  <div class="skip" *ngIf="!appContext">
    <a role="button" (click)="onSkip()">Skip</a>
  </div>
</div>
